import { LanguageType } from '@/custom-types';
import { UnityStatusOption } from '@/graphql/generated';

export const unityStatusOptionMapper = (status: UnityStatusOption, language: LanguageType) => {
  const statusMap = {
    en: {
      VACANT: 'Vacant',
      OCCUPIED: 'Occupied',
      NOT_AVAILABLE: 'Not Available',
    },
    es: {
      VACANT: 'Libre',
      OCCUPIED: 'Ocupado',
      NOT_AVAILABLE: 'No disponible',
    }
  }

  return statusMap[language][status]
}
